import { createViewService } from "../utils/client";
import { handleApiError } from "../utils/errors";
import { chalk, formatOutput, formatPagination, formatViewTable, extractSectionOrder, isInteractiveOutput } from "../utils/format";
import type { ViewItem } from "../../../../src/lib/services/view.service";

export async function listViews(
  token?: string,
  apiUrl?: string,
  options?: {
    limit?: number;
    offset?: number;
    project_id?: number | string;
    visibility?: "Public" | "Private";
    json?: boolean;
  },
): Promise<void> {
  try {
    const service = await createViewService(token, apiUrl);
    const result = await service.listViews({
      limit: options?.limit || 10,
      offset: options?.offset || 0,
      visibility: options?.visibility ? options.visibility : undefined,
      project_id: options?.project_id ? Number(options.project_id) : undefined,
    });

    if (options?.json) {
      console.log(formatOutput(result, true));
    } else {
      if (result.views && result.views.length > 0) {
        if (isInteractiveOutput()) {
          console.log("");
          console.log(chalk.bold.white("  Views"));
        }
        console.log(formatViewTable(result.views));

        if (result.has_more && isInteractiveOutput()) {
          console.log(
            chalk.dim(
              "\n  " +
                formatPagination(
                  result.offset || 0,
                  result.limit || 10,
                  result.total || 0,
                  true,
                ),
            ),
          );
        }
        if (isInteractiveOutput()) console.log("");
      } else {
        console.log(chalk.dim("\n  No views found\n"));
      }
    }
  } catch (error) {
    handleApiError(error);
  }
}

export async function getView(
  token?: string,
  apiUrl?: string,
  options?: {
    viewId: string;
    json?: boolean;
  },
): Promise<void> {
  try {
    const service = await createViewService(token, apiUrl);
    const result = await service.getView({ viewId: options?.viewId });

    if (options?.json) {
      console.log(formatOutput(result, true));
      return;
    }

    const v: ViewItem = result.view;
    if (!v) {
      console.log(chalk.dim("\n  View not found\n"));
      return;
    }

    const visibility =
      v.visibility === "Public"
        ? chalk.green("Public")
        : chalk.magenta("Private");
    const owner = v.owner?.displayName || v.owner?.email || "—";
    const defaultBadge = v.is_default ? chalk.yellow("  [default]") : "";

    console.log("");
    console.log(
      `  ${chalk.bold.white(v.title)}${defaultBadge}  ${visibility}`,
    );
    console.log(chalk.dim("  " + "─".repeat(40)));
    console.log(
      `  ${chalk.dim("Project")}      ${chalk.cyan(v.project?.title || v.project?.name || "—")}`,
    );
    console.log(`  ${chalk.dim("Created by")}   ${owner}`);
    console.log(`  ${chalk.dim("ID")}           ${chalk.dim(v.id)}`);
    console.log("");
    console.log(`  ${chalk.dim("Board settings")}`);
    console.log(
      `  ${chalk.dim("Sort")}         ${v.board_sorting_mode || "—"}  ${v.board_sorting_order || ""}`.trimEnd(),
    );
    console.log(
      `  ${chalk.dim("Subtasks")}     ${v.board_subtask_setting || "—"}`,
    );
    console.log(
      `  ${chalk.dim("Empty sect.")}  ${v.board_empty_sections || "—"}`,
    );

    const sectionsStr = extractSectionOrder(v.board_columns_view);
    if (sectionsStr && sectionsStr !== "—") {
      console.log("");
      console.log(`  ${chalk.dim("Sections")}    ${sectionsStr}`);
    }

    console.log("");
  } catch (error) {
    handleApiError(error);
  }
}


